export const idfields = [
  {
    name: "firstname",
    title: "First name",
  },
  {
    name: "surname",
    title: "Second name",
  },
  {
    name: "phonenumber",
    title: "Cell phone",
  },
  {
    name: "uid",
    title: "UID",
  },
  {
    name: "referralcode",
    title: "Referral code",
  },
  {
    name: "email",
    title: "Email",
  },
  {
    name: "dob",
    title: "Age + Birthday",
  },
  {
    name: "kyc",
    title: "KYC",
  },
  {
    name: "selfie",
    title: "Selfie Check",
  },
  {
    name: "profession",
    title: "Profession",
  },
  {
    name: "hobby",
    title: "Hobby",
  },
];



// WEBPACK FOOTER //
// ./src/Constants/idfields.js